import { msalInstance } from "../config/authConfig";
import apiClient from "../config/axiosConfig";

let tokenRefreshTimer: NodeJS.Timeout | null = null;

/**
 * Set up proactive token refresh
 * MSAL tokens typically expire after 1 hour
 * We'll refresh 5 minutes before expiration
 */
export const setupTokenRefresh = () => {
	// Clear any existing timer
	if (tokenRefreshTimer) {
		clearInterval(tokenRefreshTimer);
	}

	// Check and refresh token every 55 minutes (5 minutes before typical 1-hour expiration)
	tokenRefreshTimer = setInterval(
		async () => {
			try {
				const account = msalInstance.getActiveAccount();
				if (account) {
					console.debug("[Auth] Proactively refreshing token");

					const tokenResponse = await msalInstance.acquireTokenSilent({
						scopes: ["user.read", "profile", "openid", "email"],
						account,
						forceRefresh: true,
					});

					// Update the authorization header with new token
					const newToken = `Bearer ${tokenResponse.accessToken}`;
					apiClient.defaults.headers.common["Authorization"] = newToken;

					console.debug("[Auth] Token refreshed successfully");
				}
			} catch (error) {
				console.error("[Auth] Proactive token refresh failed:", error);
				// Don't redirect here - let the interceptor handle it when an actual API call fails
			}
		},
		55 * 60 * 1000,
	); // 55 minutes
};

/**
 * Clear the token refresh timer
 */
export const clearTokenRefresh = () => {
	if (tokenRefreshTimer) {
		clearInterval(tokenRefreshTimer);
		tokenRefreshTimer = null;
	}
};

/**
 * Get token expiration time from the cached token
 * Returns the time until expiration in milliseconds
 */
export const getTokenExpirationTime = (): number | null => {
	try {
		const account = msalInstance.getActiveAccount();
		if (!account) return null;

		// Get all tokens for the account
		const tokens = msalInstance.getAllAccounts();
		if (tokens.length === 0) return null;

		// MSAL stores token metadata including expiration
		// For now, we'll assume standard 1-hour expiration
		// In production, you might want to decode the JWT to get actual expiration
		return 60 * 60 * 1000; // 1 hour in milliseconds
	} catch (error) {
		console.error("[Auth] Error getting token expiration:", error);
		return null;
	}
};
